<template>
  <v-select v-model="input"
            :items="contracts"
            outline
            label="Договор"
            :item-text="item => `${item.number} от ${item.date.format('DD.MM.YYYY')} ${item.isPrimary ? '(Основной)' : ''}`"
            :item-value="item => item.id"
            :dense="dense"
            :error="error"
            :outlined="outlined"
            @change="onInputChanged"
            :hide-details="!error"
  >

    <template v-slot:no-data>
      У вас нет договоров для выбора
    </template>

    <template v-slot:append-outer v-if="(allowAdd && input) || allowAdd">
      <v-dialog v-model="edit.dialog" max-width="360px" v-if="allowAdd && input">
        <template v-slot:activator="{ }">
          <v-btn small text color="primary" @click="onOpenEditDialogButtonClicked">
            <v-icon small>fa-pen</v-icon>
          </v-btn>
          <v-snackbar
              v-model="edit.success"
              :timeout="5000"
              color="success"
              outlined
              bottom
              right
          >
            Договор изменён
          </v-snackbar>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Изменить договор</span>
          </v-card-title>
          <v-container>
            <v-row>
              <v-col>
                <v-col>
                  <v-text-field v-model="edit.number" :dense="true" label="Номер договора" :hide-details="true"
                                :error="$v.edit.number.$error"
                  />
                </v-col>
                <v-col>
                  <date-input v-model="edit.date" :dense="true" label="Дата договора" :hide-details="true"
                              :append-icon="true" :prepend-icon="false"
                              :error="$v.edit.date.$error"
                  />
                </v-col>
                <v-col>
                  <v-checkbox v-model="edit.isPrimary" label="Основной"/>
                </v-col>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-btn color="secondary darken-1" text @click="edit.dialog = false">Закрыть</v-btn>
            <v-spacer/>
            <v-btn color="blue darken-1" dark @click="onEditContractButtonClicked">Изменить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="add.dialog" max-width="360px" v-if="allowAdd">
        <template v-slot:activator="{ on, attrs }">
          <v-btn small text color="success"
                 v-bind="attrs"
                 v-on="on"
          >
            <v-icon small>fa-plus</v-icon>
          </v-btn>
          <v-snackbar
              v-model="add.success"
              :timeout="5000"
              color="success"
              outlined
              bottom
              right
          >
            Договор добавлен
          </v-snackbar>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Добавить договор</span>
          </v-card-title>
          <v-container>
            <v-row>
              <v-col>
                <v-col>
                  <v-text-field v-model="add.number" :dense="true" label="Номер договора" :hide-details="true"
                                :error="$v.add.number.$error"
                  />
                </v-col>
                <v-col>
                  <date-input v-model="add.date" :dense="true" label="Дата договора" :hide-details="true"
                              :append-icon="true" :prepend-icon="false"
                              :error="$v.add.date.$error"
                  />
                </v-col>
                <v-col>
                  <v-checkbox v-model="add.isPrimary" label="Основной"/>
                </v-col>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-btn color="secondary darken-1" text @click="add.dialog = false">Закрыть</v-btn>
            <v-spacer/>
            <v-btn color="blue darken-1" dark @click="onAddContractButtonClicked">Добавить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-select>
</template>

<script>

import ContractService from '@/services/contract.service'
import _ from "underscore";
import Moment from "moment";
import DateInput from "@/components/Input/DateInput";
import {required} from 'vuelidate/lib/validators'
import {validationMixin} from 'vuelidate'

const EventContractsLoaded = 'EventContractsLoaded'

export default {
  name: "SelectContract",
  components: {DateInput},
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      default: null
    },
    dense: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    buyerInn: {
      type: String,
      default: ''
    },
    autoSelectPrimary: {
      type: Boolean,
      default: true
    },
    allowAdd: {
      type: Boolean,
      default: true
    },
    allowEdit: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: Object,
      default: null
    },
    outlined: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      contracts: [],
      input: null,

      add: {
        dialog: false,
        success: false,

        number: '',
        date: null,
        isPrimary: false
      },
      edit: {
        dialog: false,
        success: false,

        number: '',
        date: null,
        isPrimary: false
      },

      isDefaultValueApplied: false
    }
  },
  validations: {
    add: {
      number: {
        required
      },
      date: {
        required
      }
    },
    edit: {
      number: {
        required
      },
      date: {
        required
      }
    }
  },
  methods: {
    loadContracts() {
      if (this.buyerInn) {
        ContractService.getSellerContracts({buyer: this.buyerInn})
            .then(response => {
                  this.contracts = _.map(response.data, contract => {
                    return {
                      id: contract.id,
                      date: Moment(contract.date, 'YYYY-MM-DD'),
                      number: contract.number,
                      isPrimary: contract.is_primary,
                      buyerInn: contract.buyer_inn,
                      sellerInn: contract.seller_inn
                    }
                  })
              this.$emit(EventContractsLoaded)
            })
          
      }
    },
    syncInputFromValue() {
      if (this.value)
        this.input = this.value.id
    },
    applyDefault() {
      if (this.defaultValue && this.contracts.length && !this.isDefaultValueApplied) {
        let contract = this.contracts.find(c => {
          return c.number === this.defaultValue.number && c.date.format('YYYY-MM-DD') === this.defaultValue.date.format('YYYY-MM-DD')
        });

        if (contract) {
          this.isDefaultValueApplied = true

          this.input = contract.id
          this.onInputChanged()
        }
      }
    },

    onInputChanged() {
      let contract = _.find(this.contracts, c => {
        return c.id === this.input
      }) || null

      this.$emit("input", contract);
      this.$emit("change", contract);
    },
    onEventContractsLoaded() {
      if (this.autoSelectPrimary && !this.value) {
        let primaryContract = _.find(this.contracts, c => {
          return c.isPrimary
        })
        if (primaryContract) {
          this.input = primaryContract.id
          this.onInputChanged()
        }
      }

      this.applyDefault()
    },
    onOpenEditDialogButtonClicked() {
      this.edit.number = this.value.number
      this.edit.date = this.value.date
      this.edit.isPrimary = this.value.isPrimary

      this.$v.edit.$reset()
      this.edit.dialog = true
    },

    onAddContractButtonClicked() {
      this.$v.add.$touch()
      if (!this.$v.add.$invalid) {
        ContractService.addSellerContract({
          seller: this.$store.getters.companyInn,
          buyer: this.buyerInn,
          number: this.add.number,
          date: this.add.date,
          isPrimary: this.add.isPrimary
        })
            .then(() => {
              this.add.success = true
              this.add.dialog = false

              this.add.number = ''
              this.add.date = null
              this.add.isPrimary = false

              this.$v.add.$reset()

              this.loadContracts()
            })
      }
    },

    onEditContractButtonClicked() {
      this.$v.edit.$touch()
      if (!this.$v.edit.$invalid) {
        ContractService.editSellerContract({
          id: this.value.id,
          seller: this.$store.getters.companyInn,
          buyer: this.buyerInn,
          number: this.edit.number,
          date: this.edit.date,
          isPrimary: this.edit.isPrimary
        })
            .then(() => {
              this.edit.success = true
              this.edit.dialog = false

              this.edit.number = ''
              this.edit.date = null
              this.edit.isPrimary = false

              this.$v.edit.$reset()

              this.loadContracts()
            })
      }
    }
  },
  created() {
    this.$on(EventContractsLoaded, this.onEventContractsLoaded)
    this.syncInputFromValue()
    this.loadContracts()
  },
  beforeDestroy() {
    this.$off(EventContractsLoaded, this.onEventContractsLoaded)
  },
  watch: {
    value() {
      this.syncInputFromValue();
    },
    buyerInn() {
      this.loadContracts()
    },
    defaultValue() {
      this.isDefaultValueApplied = false
      this.applyDefault()
    }
  }
}
</script>

<style scoped>

</style>